import _ from 'lodash';
import APPROVAL_TYPE from '../constants/approvalType';
import APPROVAL_STATUSES from '../constants/approvalStepStatuses';
export const isForcedProgressionItemIncomplete = (sectionItem) => {
    if (sectionItem.itemType === 'Approval') {
        return (_.get(sectionItem, 'item.approvalType') ===
            APPROVAL_TYPE.BLOCK_PROGRESS &&
            !(sectionItem.isCompleted ||
                sectionItem.approvalStatus === APPROVAL_STATUSES.APPROVED));
    }
    return sectionItem.isCompleted === false;
};
export const getFirstForcedProgressionItem = (course) => _((course && course.sections) || [])
    .filter(section => !section.isContentHidden)
    .map('items')
    .flatten()
    .find(isForcedProgressionItemIncomplete);
export const isItemDisabledByForcedProgression = (course, sectionItem, firstIncompleteItem = getFirstForcedProgressionItem(course)) => Boolean(course.forcedProgression &&
    isForcedProgressionItemIncomplete(sectionItem) &&
    _.get(sectionItem, 'item._id', '') !==
        _.get(firstIncompleteItem, 'item._id'));
export const isItemBlockedByApprovalStep = (course, sectionItem) => {
    const items = _((course && course.sections) || [])
        .filter(section => !section.isContentHidden)
        .map('items')
        .flatten()
        .value();
    const blockingApprovalIndex = items.findIndex(item => item.itemType === 'Approval' &&
        item.item?.approvalType === APPROVAL_TYPE.BLOCK_PROGRESS &&
        !(item.isCompleted || item.approvalStatus === APPROVAL_STATUSES.APPROVED));
    const sectionItemIndex = items.findIndex(item => item.item?._id === sectionItem.item?._id);
    return (blockingApprovalIndex !== -1 && sectionItemIndex > blockingApprovalIndex);
};
export const isItemInHiddenSection = (course, sectionItem) => Boolean(((course && course.sections) || []).find(section => section.isContentHidden &&
    section.items?.some(item => item.item?._id === sectionItem.item?._id)));
export const getForcedProgressionItemPath = (course, sectionItem = getFirstForcedProgressionItem(course)) => {
    if (!course.slug || !sectionItem) {
        return undefined;
    }
    if (sectionItem.itemType === 'Lesson') {
        const slug = _.get(sectionItem, 'item.slug');
        return slug ? `/courses/${course.slug}/lessons/${slug}` : undefined;
    }
    if (sectionItem.itemType === 'Quiz') {
        const id = _.get(sectionItem, 'item._id');
        return id ? `/courses/${course.slug}/quizzes/${id}` : undefined;
    }
    return `/courses/${course.slug}`;
};
